var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('import-clients-modal',{ref:"modal",attrs:{"can-upload":_vm.canImport}})}
var staticRenderFns = []

export { render, staticRenderFns }